import React, { FC, useEffect } from 'react';
import { ConfigProvider, Divider, Modal } from 'antd';
import { IoIosClose } from 'react-icons/io';
import { __30PayModalProps } from './30payModal.interface';

export const _SiPayModal: FC<__30PayModalProps> = (props: __30PayModalProps) => {
    useEffect(() => {
        if (props.isOpen) document.body.style.overflow = 'hidden';
        else document.body.style.overflow = 'auto';
    }, [props.isOpen]);

    return (
        <ConfigProvider
            theme={{
                components: {
                    Modal: {
                        titleFontSize: 20,
                    },
                },
                token: {
                    borderRadius: 16,
                    padding: 24,
                },
            }}
        >
            <Modal
                width={props.maxWidth}
                styles={{
                    content: {
                        border: '1px solid #D2DEFE',
                    },
                }}
                destroyOnClose
                centered
                afterClose={props.afterClose}
                closeIcon={
                    !props.disableCloseIcon ? (
                        <div
                            className={'w-5 h-5 flex items-center justify-center border border-black-100 rounded-[4px]'}
                        >
                            <IoIosClose color={'black'} />
                        </div>
                    ) : null
                }
                open={props.isOpen}
                onCancel={() => props.onClose()}
                title={props.title}
                footer={props.footer ?? <></>}
            >
                <div
                    className={`w-[calc(100%+48px)] -mr-6 px-6 ${props.title ? 'border-t border-t-background pt-4 ' : ''}   `}
                >
                    {props.children}
                </div>
            </Modal>
        </ConfigProvider>
    );
};
